import { Theme } from '../../components/Theme/intex'; // Corrigido o caminho
import { useHistory } from 'react-router-dom';
import { useForm, FormActions } from '../../context/FormContext';
import { ChangeEvent, useEffect, useState } from 'react';
import { Container } from './styles';
import { createHost } from '../../components/Host/createHost'; // Caminho corrigido
import Modal from '../../components/Modal'; // Importando o componente Modal

// Definindo a estrutura esperada do erro de resposta
interface ResponseError extends Error {
    response?: {
        data?: {
            message?: string;
        };
    };
}

export const FormStep2 = () => {
    const { state, dispatch } = useForm();
    const history = useHistory();
    const [isDiscoveringIp, setIsDiscoveringIp] = useState(false); // Removido isRegistered
    const [hostCount, setHostCount] = useState(0);
    const [modalMessage, setModalMessage] = useState('');
    const [errors, setErrors] = useState({
        host: false,
        ip: false,
    });

    useEffect(() => {
        if (state.name === '') {
            history.push('/');  // Redireciona para a home se não houver dados
        } else {
            dispatch({
                type: FormActions.setCurrentStep,
                payload: 2
            });
        }
    }, [dispatch, history, state.name]);

    const handleNextStep = async () => {
        if (state.host.trim() === '' && state.ip.trim() === '') {
            history.push('/step3');  // Redirecionamento para a próxima etapa
        } else {
            if (validateForm()) {
                await registerHost();
                history.push('/step3');  // Redirecionamento para a próxima etapa após cadastro
            } else {
                setModalMessage('Preencha todos os dados corretamente antes de cadastrar.');
            }
        }
    };

    const sanitizeHostName = (name: string): string => {
        return name.replace(/[^a-zA-Z0-9\s]/g, '').trim();
    };

    const registerHost = async () => {
        if (hostCount >= 5) {
            setModalMessage('O IMS Free Tier só permite cadastro de 5 hosts.\nEntre em contato para maiores informações!');
            clearForm(); // Limpa o formulário após mensagem de erro
            return;
        }

        const prefix = state.name;
        const sanitizedHostName = sanitizeHostName(state.host);
        const hostNameWithPrefix = `IMS Free Tier - ${prefix} - ${sanitizedHostName}`;

        // Adiciona logs para registrar os valores
        console.log('Nome do Host:', hostNameWithPrefix);
        console.log('IP do Host:', state.ip);
        console.log('Group ID:', state.groupid);

        try {
            const response = await createHost(sanitizedHostName, 1, state.ip, '30345', state.groupid, prefix); // Usando '30345' como ID padrão
            console.log('Host cadastrado com sucesso!', response);
            setModalMessage(`Host ${response.hostName}\nCadastrado com sucesso!`);
            setHostCount(hostCount + 1); // Incrementa o contador de hosts cadastrados
            dispatch({ type: FormActions.setHosts, payload: [...state.hosts, { name: hostNameWithPrefix, ip: state.ip }] }); // Adiciona o host ao estado
            clearForm(); // Limpa o formulário após cadastro
        } catch (error) {
            console.error('Erro ao cadastrar o host:', error);

            // Verifique se é um ResponseError e se tem a estrutura esperada
            const responseError = error as ResponseError;
            const errorMessage = responseError.message || 'Erro ao cadastrar o host. Entre em contato para que possamos ajudar!';
            setModalMessage(errorMessage);
        }
    };

    const clearForm = () => {
        dispatch({ type: FormActions.setHost, payload: '' });
        dispatch({ type: FormActions.setIp, payload: '' });
        setErrors({ host: false, ip: false });
    };

    const validateForm = () => {
        const newErrors = {
            host: state.host.trim() === '',
            ip: state.ip.trim() === ''
        };
        setErrors(newErrors);
        return !newErrors.host && !newErrors.ip;
    };

    const handleNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch({
            type: FormActions.setHost,
            payload: e.target.value
        });
    };

    const handleIpChange = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch({
            type: FormActions.setIp,
            payload: e.target.value
        });
    };

    const handleRegisterHost = async () => {
        if (validateForm()) {
            await registerHost();
        } else {
            setModalMessage('Preencha todos os dados corretamente antes de cadastrar.');
        }
    };

    const discoverIp = async () => {
        setIsDiscoveringIp(true);
        try {
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            dispatch({
                type: FormActions.setIp,
                payload: data.ip
            });
        } catch (error) {
            console.error('Erro ao descobrir o IP:', error);
            setModalMessage('Erro ao descobrir o IP.');
        } finally {
            setIsDiscoveringIp(false);
        }
    };

    const closeModal = () => {
        setModalMessage('');
    };

    return (
        <Theme>
            <Container>
                <div className='passo'>Passo 2/3</div>
                <h2>Legal {state.name}, vamos cadastrar um host para monitorar</h2>
                <p>Preencha os campos abaixo e clique em "Cadastrar". Até 5 hosts podem ser cadastrados.</p>
                <p>Quando terminar clique em "Finalizar"</p>

                <label>Nome do Host</label>
                <input 
                    type="text" 
                    placeholder="O nome que vai identificar seu ativo monitorado"
                    value={state.host}
                    onChange={handleNameChange}
                    className={errors.host ? 'error' : ''}
                />

                <label>IP público</label>
                <div className="ip-container">
                    <input 
                        type="text" 
                        placeholder="Informe o IP externo do ativo, caso não saiba clique no botão ao lado"
                        value={state.ip}
                        onChange={handleIpChange}
                        style={{ marginRight: '10px' }}
                        className={errors.ip ? 'error' : ''}
                        disabled={isDiscoveringIp}
                    />
                    <button className="ip-button" onClick={discoverIp} disabled={isDiscoveringIp}>
                        Seu IP
                    </button>
                </div>

                {isDiscoveringIp && <div>Estamos validando seu ip externo!</div>}

                <div className="button-container">
                    <button onClick={handleRegisterHost}>Cadastrar</button>
                    <button className="right-button" onClick={handleNextStep}>Finalizar</button>
                </div>

                {modalMessage && <Modal message={modalMessage} onClose={closeModal} />}
            </Container>
        </Theme>
    );
};
